import React from 'react';  
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import './Sliderb.css';

import { Typography, Button, Box, Container } from '@mui/material';
import { motion } from 'framer-motion';
import sliderImage from './sliderImage';

function Sliderb() {
    const [slideKey, setSlideKey] = React.useState(0);

    const handleSlideChange = (swiper) => {
        setSlideKey(swiper.activeIndex); // Atualiza o estado com o índice do slide ativo
    };

    return (
 
        <Swiper
        modules={[Autoplay]}
        spaceBetween={0}
        slidesPerView={1}
        autoplay={{ delay: 10000, disableOnInteraction: false }}
        pagination={{ clickable: true }}
        onSlideChange={handleSlideChange}
        className="custom-slider"
    >
        {sliderImage.map((item, index) => (
            <SwiperSlide key={index}>
                <Box
                    className="slider-content"
                    sx={{
                        backgroundImage: `url('${item.image}')`,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: '100vw',
                        height: '100vh',
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        textAlign: 'center',
                        px: 3,
                        opacity: slideKey === index ? 1 : 0, // Fará com que os outros slides tenham opacidade 0
                        visibility: slideKey === index ? 'visible' : 'hidden', // Garante que apenas o slide atual será visível
                        transition: 'opacity 1s ease', // Suaviza a transição da opacidade
                    }}
                >
                    <motion.div
                        className="inner"
                        key={slideKey}
                        initial={{ opacity: 0, y: 50 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 1, ease: 'easeOut' }}
                    >
                        <Typography
                            variant="h6"
                            sx={{
                                fontFamily: 'Lato, sans-serif',
                                fontSize: '24px',
                                fontWeight: 400,
                                color: '#fff',
                                letterSpacing: '1px',
                                mb: 2,
                                textTransform: 'uppercase',
                            }}
                        >
                            {item.subtitle}
                        </Typography>
     
                        <Typography
             variant="h3"
             align="center"
             gutterBottom
             style={{
               fontFamily: "'Lato', serif",
               color: "white",
               borderBottom: "4px solid #d4af37",
               paddingBottom: "10px",
               textTransform: "uppercase",
               animation: "glow 2s infinite alternate",
               textShadow: '2px 2px 4px rgba(0, 0, 0, 0.5)',  // Sombra preta

               marginTop: "7%"  // Aqui é onde você define o espaço superior
             }}
           > 
                            {item.title}
                        </Typography>
    
                        <Typography
                            variant="body1"
                            sx={{
                                fontFamily: 'Lato, sans-serif',
                                fontSize: { xs: '16px', md: '18px' },
                                lineHeight: 1.8,
                                color: '#fff',
                                textAlign: 'center',
                                mb: 4,
                                textShadow: '2px 2px 4px rgba(0, 0, 0, 0.5)',
                            }}
                        >
                            {item.description}
                        </Typography>
    
                        <a href={item.path} style={{ textDecoration: 'none' }}>
                            <Button
                                variant="contained"
                                component={motion.div}
                                whileHover={{ scale: 1.1 }}
                                transition={{ type: 'spring', stiffness: 300 }}
                                sx={{
                                    backgroundColor: '#d4af37',
                                    color: '#faf9f9',
                                    padding: '12px 24px',
                                    fontSize: '18px',
                                    fontWeight: 'bold',
                                    borderRadius: '50px',
                                    transition: 'transform 0.3s ease, background-color 0.3s ease',
                                    '&:hover': {
                                        backgroundColor: '#800020',
                                    },
                                }}
                            >
                                {item.button}
                            </Button>
                        </a>
                    </motion.div>
                </Box>
            </SwiperSlide>
        ))}
    </Swiper>
    
    );
}

export default Sliderb;
